import React from 'react';
import {
  Bell, AlertOctagon, Tags, Building, Boxes, Receipt, TrendingUp, Truck, Undo2,
  ClipboardCheck, Users, ClipboardList, MapPin, IdCard, Activity, RefreshCcw, ShieldCheck,
} from 'lucide-react';
import ComingSoonPage from './ComingSoonPage';

/* Central registry — all new placeholder routes plug in here.
   Add a row and register the route in App.js to expose it. */
const CATALOG = {
  'notifications':          { testId: 'notifications-page',         title: 'Notifications',              arabicTitle: 'التنبيهات',                    icon: Bell,            accent: '#F59E0B',
    description: 'مركز التنبيهات الفورية عبر جميع الوحدات — البلاغات الحرجة، التوريدات المتأخرة، الزيارات القادمة، وانتهاء العقود.' },

  'emergency-maintenance':  { testId: 'emergency-maintenance-page', title: 'Emergency Maintenance',       arabicTitle: 'الصيانة الطارئة',              icon: AlertOctagon,    accent: '#EF4444',
    description: 'قناة الصيانة الطارئة السريعة — بلاغات ذات أولوية حرجة تحتاج تدخلاً خلال ساعات.' },
  'incident-categories':    { testId: 'incident-categories-page',   title: 'Incident Categories',         arabicTitle: 'تصنيفات البلاغات',             icon: Tags,            accent: '#8B5CF6',
    description: 'المرجع الرئيسي لأنواع بلاغات الصيانة — سيتم ربطه بملف Excel المستورَد ليكون المصدر الموحّد لكل التصنيفات.' },

  'suppliers':              { testId: 'suppliers-page',             title: 'Suppliers',                   arabicTitle: 'الموردون',                     icon: Building,        accent: '#8B5CF6',
    description: 'سجل الموردين الكامل مع مؤشرات الأداء، العقود المرتبطة، والتوريدات السابقة.' },
  'supply-items':           { testId: 'supply-items-page',          title: 'Items',                       arabicTitle: 'الأصناف',                       icon: Boxes,           accent: '#6FA8FF',
    description: 'كتالوج الأصناف الموحّد — الوصف، وحدة القياس، الموردون المعتمدون، وسعر التوريد المرجعي.' },
  'lpc-statements':         { testId: 'lpc-statements-page',        title: 'LPC Statements',              arabicTitle: 'بيانات LPC',                    icon: Receipt,         accent: '#F59E0B',
    description: 'بيانات LPC وسجلات الاستلام والقبول لكل توريد.' },
  'supply-progress':        { testId: 'supply-progress-page',       title: 'Supply Progress',             arabicTitle: 'تقدم التوريد',                 icon: TrendingUp,      accent: '#10B981',
    description: 'مقاييس التقدم اللحظية لكل عقد ومورّد — النسبة المئوية للإنجاز، الجدول الزمني، والانحرافات.' },
  'supply-distribution':    { testId: 'supply-distribution-page',   title: 'Distribution',                arabicTitle: 'التوزيع',                       icon: Truck,           accent: '#6FA8FF',
    description: 'خطة توزيع الأصناف على المدارس، الجداول الزمنية، ومسارات التسليم.' },
  'supply-returns':         { testId: 'supply-returns-page',        title: 'Returns',                     arabicTitle: 'المرتجعات',                     icon: Undo2,           accent: '#EF4444',
    description: 'سجل المرتجعات والاستبدالات — الأسباب، الحالات، والإجراءات التصحيحية.' },

  'construction-projects':  { testId: 'construction-projects-page', title: 'Construction Projects',       arabicTitle: 'مشاريع الإنشاء',               icon: ClipboardCheck,  accent: '#8B5CF6',
    description: 'إدارة مشاريع البناء والإنشاء — النطاق، الجدول الزمني، الميزانية، والمخاطر.' },
  'construction-engineers': { testId: 'construction-engineers-page',title: 'Construction Engineers',      arabicTitle: 'مهندسو الإنشاء',                icon: Users,           accent: '#6FA8FF',
    description: 'سجل مهندسي الإنشاء ومسؤولياتهم عن مشاريع البناء.' },
  'construction-work-orders':{ testId: 'construction-work-orders-page', title: 'Construction Work Orders', arabicTitle: 'أوامر عمل الإنشاء',           icon: ClipboardList,   accent: '#F59E0B',
    description: 'أوامر العمل الإنشائية — التعيينات، حالات التنفيذ، والاستلامات.' },
  'construction-visits':    { testId: 'construction-visits-page',   title: 'Construction Site Visits',    arabicTitle: 'زيارات الإنشاء',               icon: MapPin,          accent: '#10B981',
    description: 'زيارات مواقع الإنشاء — التقارير، الصور، وتقييم التقدم الفعلي مقابل المخطط.' },

  'school-info':            { testId: 'school-info-page',           title: 'School Information',          arabicTitle: 'بيانات المدرسة',                icon: IdCard,          accent: '#6FA8FF',
    description: 'البطاقة التعريفية الكاملة لكل مدرسة — العنوان، الطاقم، السعة، والبيانات الديموغرافية.' },
  'school-equipment':       { testId: 'school-equipment-page',      title: 'School Equipment',            arabicTitle: 'تجهيزات المدارس',              icon: Boxes,           accent: '#8B5CF6',
    description: 'سجل تجهيزات كل مدرسة، حالة كل تجهيز، وسجل الصيانة الوقائية.' },
  'school-status':          { testId: 'school-status-page',         title: 'School Status',               arabicTitle: 'حالة المدرسة',                  icon: Activity,        accent: '#10B981',
    description: 'الحالة التشغيلية الشاملة لكل مدرسة — جاهزية، صيانة، توريد، ومؤشرات مركّبة.' },

  'contract-renewals':      { testId: 'contract-renewals-page',     title: 'Contract Renewals',           arabicTitle: 'تجديدات العقود',                icon: RefreshCcw,      accent: '#F59E0B',
    description: 'العقود القريبة من الانتهاء، خطط التجديد، والتنبيهات الآلية.' },
  'contract-warranties':    { testId: 'contract-warranties-page',   title: 'Warranties',                  arabicTitle: 'الضمانات',                      icon: ShieldCheck,     accent: '#10B981',
    description: 'سجل الضمانات لكل عقد وتجهيز — تواريخ الصلاحية والمطالبات.' },
};

/**
 * Factory returning a page component for a given catalog key.
 * Usage in App.js:  <Route path="/notifications" element={placeholder('notifications')} />
 */
export function placeholder(key) {
  const cfg = CATALOG[key];
  if (!cfg) return <ComingSoonPage title="Coming Soon" arabicTitle="قريباً" />;
  return <ComingSoonPage {...cfg} />;
}

/**
 * Readiness Plan — explicitly requested to remain EMPTY with a "Coming Soon" message.
 * Kept as its own component so future team can extend without touching the catalog.
 */
export function ReadinessPlanPlaceholder() {
  return (
    <ComingSoonPage
      testId="readiness-plan-page"
      title="Readiness Plan"
      arabicTitle="خطة الجاهزية"
      icon={ClipboardCheck}
      accent="#8B5CF6"
      eyebrow="قريباً"
      description="هذا القسم قيد الإعداد ولم تُفعَّل وظائفه بعد. سيتم إطلاقه في المرحلة القادمة من التطوير."
    />
  );
}
